require('./tasks.style.scss');
const { permissions } = require('../../constants/permissions');
const Task = require('../../model/Task');

class TasksController {
    constructor($scope, $element, $filter, $stateParams, $timeout, $rootScope, tasksPersistence, dialogService, utilsService, notificationService, storageService, iamPersistenceService) {
        this.$scope = $scope;
        this.$element = $element;
        this.$filter = $filter;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.dialogService = dialogService;
        this.utilsService = utilsService;
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.persistence = tasksPersistence;
        this.iamPersistenceService = iamPersistenceService;
        this.selectedIndex = -1;
        this.isMini = false;

        this.$scope.$on('jobs.refresh.ok', () => {
            this.refresh();
        });

        this.$scope.$on('sub-changed', () => {
            this.refresh(true);
        });
        this.expandedTasks = {};
    }

    $onInit() {
        this.filterFlag = 0;
        this.stateParamsFilterInit();
        this.persistence.initDropdownFilters();
        this.persistence.selectedTasks = [];
        this.reportLabel = this.$filter('translate')('tasks.details.actionReport.label');
        this.refresh(null, true);
        this.filterFlag++;

        this.destroyBroadcastCatcher = this.$rootScope.$on("subscriptionChanged", () => {
            this.refresh(null, true);
            this.persistence.initDropdownFilters();
        });
    }

    $onDestroy() {
        this.destroyBroadcastCatcher();
    }

    load(firstPage, firstLoad, clearSelection) {
        this.busy = true;
        this.expandedTasks = {};
        if (clearSelection) {
            this.shownDetailsIndex = false;
            this.persistence.selectedTasks = [];
        }
        if (firstLoad && this.$stateParams.jobUuid) {
            firstPage = true;
        }
        return this.persistence.getTasks(firstPage).then(() => {
            if (firstLoad && this.persistence.tasks.length) {
                this.$timeout(() => {
                    if (this.$stateParams.jobUuid) {
                        this.persistence.selectedTasks = this.persistence.tasks.filter(job => {
                            if (job.uuid === this.$stateParams.jobUuid) {
                                job._selected = true;
                                return job;
                            }
                        });
                    }
                    else {
                        this.persistence.tasks[0]._selected = true;
                        this.persistence.selectedTasks[0] = this.persistence.tasks[0];
                    }
                    this.showDetails(this.persistence.selectedTasks[0]);
                }, 0);
            }
            else if (this.persistence.selectedTasks && this.persistence.selectedTasks[0]) {
                this.$timeout(() => {
                    this.persistence.selectedTasks = this.persistence.tasks.filter(job => job.uuid === this.persistence.selectedTasks[0].uuid);
                    if (!this.persistence.selectedTasks[0]) {
                        this.shownDetailsIndex = false;
                        return;
                    }
                    this.persistence.selectedTasks[0]._selected = true;
                }, 0);
            }
        }, err => {
            this.persistence.tasks = [];
            this.persistence.selectedTasks = [];
            this.shownDetailsIndex = false;
        }).finally(() => {
            this.isMini = false;
            this.busy = false;
        });
    }

    stateParamsFilterInit() {
        let statusFilter, nameFilter, jobUuidFilter,
            stateParam = this.$stateParams.statusFilter,
            nameParam = this.$stateParams.nameFilter,
            jobParam = this.$stateParams.jobUuid;
        if (!stateParam && !nameParam && !jobParam) return;

        this.persistence.clearFilter();
        if (stateParam) {
            statusFilter = this.persistence.filters.filter(item => item.filterKey === Task.getStatusKey())[0];
            statusFilter.setOptionByValue(stateParam);
        }
        if (nameParam) {
            nameFilter = this.persistence.filters.filter(item => item.filterKey === Task.getSearchKey())[0];
            nameFilter.setOptionByValue(nameParam.replace(/["]+/g, "\'"));
        }
        if (jobParam) {
            jobUuidFilter = this.persistence.filters.filter(item => item.filterKey === Task.getIdKey())[0];
            jobUuidFilter.setOptionByValue(jobParam);
        }
    }

    setGrid(grid, refresh) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('66%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('8%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('13%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('13%');
        this.$timeout(() => {
            let user = this.storageService.getUser();
            this.grid.tableName = (refresh ? grid.tableId : this.grid.tableName) + '-' + user.username + '-' + user.userGroupName;
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    showDetails(item) {
        this.shownDetailsIndex = item && item._selected ? item.uuid : false;
        if (this.shownDetailsIndex && this.iamPersistenceService.hasPermissions(permissions.TASK_DETAILS)) {
            this.busyTaskDetails = true;
            this.persistence.getTaskDetails(item, this.$scope).then(res => this.setTaskDetails(res));
        } else {
            this.isMini = false;
            this.busyTaskDetails = false;
        }
    }

    abortDialog() {
        this.dialogService.showYesNo(this.$filter('translate')('task.abort.message'), this.$filter('translate')('task.toolbar.abort.label'), null, 'abort-job')
            .then(result => {
                return result ? this.abortTask() : result;
            }).then(() => {
            }, err => this.err = err);
    }

    abortTask() {
        this.busy = true;
        this.persistence.abortTask(this.persistence.selectedTasks[0])
            .then(resp => {
                this.notificationService.pop(resp.data.message);
                this.refresh(true);
            }, err => {
                this.refresh(true);
            });
    }

    setTaskDetails(task) {
        this.taskDetails = [
            {
                detail: this.$filter('translate')('tasks.details.uuid'),
                value: task.uuid,
                icon: 'icon-copy',
                id: 'task-uuid'
            },
            {
                detail: this.$filter('translate')('tasks.details.type'),
                value: this.utilsService.enumToNiceString(task.type)
            },
            {
                detail: this.$filter('translate')('tasks.details.authorityEmail'),
                value: task.authorityEmail
            },
            {
                detail: this.$filter('translate')('tasks.details.vmName'),
                value: task.vmName
            },
            {
                detail: this.$filter('translate')('tasks.details.source'),
                value: task.source
            },
            {
                detail: this.$filter('translate')('tasks.details.target'),
                value: task.target
            },
        ];

        if (task.virtualMachineSnapshots && task.virtualMachineSnapshots.length > 0) {
            let snapshots = task.virtualMachineSnapshots.map((snapshot, i) => {
                return {
                    detail: snapshot.name,
                    value: '',
                    hyperLink: snapshot.uri,
                    class: 'ctx-link-decoration'
                };
            });
            this.taskDetails.push({
                detail: this.$filter('translate')('tasks.details.virtualMachineSnapshots'),
                value: '',
                subItems: snapshots
            });
        }

        this.persistence.selectedTask = task;
        this.busyTaskDetails = false;
    }

    checkForProperty(entity, property, condition) {
        if (_.has(entity, property)) {
            let restore = entity[property];
            if (_.includes(restore[0], condition)) {
                let splited = restore[0].split(condition);
                let formatedDate = '';
                restore[0] = '';
                for (let i = 0; i < splited.length; i++) {
                    let onlyDate = splited[i].substr(0, 13);
                    let data = splited[i].substr(13, splited[i].length);
                    if (onlyDate.length === 13 && !isNaN(onlyDate)) {
                        formatedDate = this.$filter('localizeDate')(parseInt(onlyDate), 'shortSec');
                    }
                    if (!restore[0]) restore[0] = formatedDate ? formatedDate + data : data;
                    else restore[0] += (formatedDate ? formatedDate + data : data);
                }
            }
        }
    }

    filterRefresh() {
        this.refresh(true, null, true);
        this.persistence.initDropdownFilters();
        this.filterFlag++;
    }

    refresh(firstPage, firstLoad, clearSelection) {
        this.load(firstPage, firstLoad, clearSelection);
    }

    setSubGrid(grid) {
        this.detailsGrid = grid;
        this.ctxDetailsGridStyleConfig = {
            multiselect: false,
            columnsWidthMapInPct: []
        };
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('54%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('10%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('18%');
        this.ctxDetailsGridStyleConfig.columnsWidthMapInPct.push('18%');

        this.$timeout(() => {
            this.detailsGrid.tableName = this.detailsGrid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName))) {
                this.ctxDetailsGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.detailsGrid.tableName);
            }
            this.detailsGridColumnsStyleConfig = this.ctxDetailsGridStyleConfig;
            this.detailsGridFlag = true;
        }, 0);
    }

    toggleChildTasks(task, event) {

        task = this.persistence.tasks.filter(x => x.uuid === task.uuid)[0];

        // event.stopPropagation();
        this.expandedTasks[task.uuid] = !this.expandedTasks[task.uuid];

        if (this.expandedTasks[task.uuid]) {
            task.childTasks.map(j => {
                if (!j.timesConverted) {
                    this.persistence.setStartFinishedTime(j);
                    j.timesConverted = true;
                }
                return Task.fromRaw;
            });
            let i = this.persistence.tasks.indexOf(task) + 1;
            this.persistence.tasks.splice(i, 0, ...task.childTasks); //add childTasks array to tasks
        } else {
            let uuids = [];
            task.childTasks.forEach(item => uuids.push(item.uuid));
            this.persistence.tasks = this.persistence.tasks.filter(item => uuids.indexOf(item.uuid) === -1); //remove added childTasks from tasks array
        }
    }

    onExport(type) {
        this.busy = true;
        return this.persistence[type === 'all' ? 'getAllTasks' : 'getTasks'](null, type === 'all', { isExport: true }).then(res => {
            return res.map(item => {
                let result = {};
                result['description'] = item.name;
                result['status'] = item.status;
                result['started'] = item.startTime;
                result['finished'] = item.finishTime;
                return result;
            });
        }).finally(() => {
            this.busy = false;
        });
    }

    hardRefreshTasks() {
        this.refresh(false);
    }

    disableReport() {
        return !this.hasViewReportPermissions() || !this.persistence.selectedTasks || !this.persistence.selectedTasks.length || (this.persistence.selectedTasks[0] && this.persistence.selectedTasks[0].status === 'READY');
    }

    disableAbort() {
        return !this.hasAbortPermissions() || !this.persistence.selectedTasks || !this.persistence.selectedTasks.length || (this.persistence.selectedTasks[0] && this.persistence.selectedTasks[0].status !== 'RUNNING' && this.persistence.selectedTasks[0].status !== 'READY') || this.persistence.selectedTasks[0].type === 'RETENTION_MAINTENANCE' || this.persistence.selectedTasks[0].type === 'EXTENDED_MAINTENANCE';
    }

    hasTasksListingPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TASK_LISTING);

    }

    hasTaskDetailsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TASK_DETAILS);
    }

    hasViewReportPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TASK_REPORT);
    }

    hasAbortPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.TASK_ABORT);
    }
}

TasksController.$inject = ['$scope', '$element', '$filter', '$stateParams', '$timeout', '$rootScope', 'tasksPersistence', 'dialogService', 'utilsService', 'notificationService', 'storageService', 'iamPersistenceService'];
const tasksComponent = {
    controller: TasksController,
    template: require('./tasks.template.html'),
};

module.exports = tasksComponent;



// WEBPACK FOOTER //
// ./src/azurebackup/views/tasks/tasks.component.js